// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_label__sZCjl {
  margin: 0 0 5px 5px;
}

.styles_status__WYAil {
  margin-top: 23px;
}

.styles_rowControl__vU0fK {
  padding: 10px 0px 0px 0px;
}

.styles_clearButton__hdVc1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.styles_clearButton__hdVc1:hover {
  background: #f44336;
  color: white;
}

.styles_addButtonCol__yvb96 {
  display: flex;
  align-items: center;
}

.styles_clearButtonCol__uTMOL {
  display: flex;
  align-items: center;
}

.styles_loading__8psuw {
  display: flex;
  align-items: center;
}

.styles_spaceBetween__-R1zP {
  display: flex;
  justify-content: space-between;
}

.styles_containerBanck__-f2ZL {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 25px;
}

.styles_bankName__e4E3F {
  text-transform: uppercase;
}

.styles_bankName__e4E3F span {
  text-transform: capitalize;
  margin: 0 5px;
}

.styles_modalHeader__3Mg4m {
  height: 55px;
}

.styles_form__C\\+2PH {
  width: 900px;
  height: 570px;
}

.styles_footer__MyHOf {
  height: 70px;
}

.styles_containerTable__0Jdnz {
  position: relative;
  z-index: 99;
}

.styles_tableZ__6oPVP {
  position: relative;
  z-index: 99;
}

.styles_table__cu6sn {
  margin-top: -52px;
  z-index: 1;
}

.styles_tableFinal__OxGzZ {
  margin-top: -52px;
  z-index: 1;
}

.styles_title__REpXs {
  font-size: 20px;
  padding-left: 24px;
  height: 20px;
}

.styles_wrapper__nC6yn {
  width: 700px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Financeiro/ExtratoBancario/ListExtratoBancario/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,0BAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,UAAA;AACF;;AAEA;EACE,iBAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".label {\n  margin: 0 0 5px 5px;\n}\n\n.status {\n  margin-top: 23px;\n}\n\n.rowControl {\n  padding: 10px 0px 0px 0px;\n}\n\n.clearButton {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.clearButton:hover {\n  background: #f44336;\n  color: white;\n}\n\n.addButtonCol {\n  display: flex;\n  align-items: center;\n}\n\n.clearButtonCol {\n  display: flex;\n  align-items: center;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n}\n\n.spaceBetween {\n  display: flex;\n  justify-content: space-between;\n}\n\n.containerBanck {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-left: 25px;\n}\n\n.bankName {\n  text-transform: uppercase;\n}\n\n.bankName span {\n  text-transform: capitalize;\n  margin: 0 5px;\n}\n\n.modalHeader {\n  height: 55px;\n}\n\n.form {\n  width: 900px;\n  height: 570px;\n}\n\n.footer {\n  height: 70px;\n}\n\n.containerTable {\n  position: relative;\n  z-index: 99;\n}\n\n.tableZ {\n  position: relative;\n  z-index: 99;\n}\n\n.table {\n  margin-top: -52px;\n  z-index: 1;\n}\n\n.tableFinal {\n  margin-top: -52px;\n  z-index: 1;\n}\n\n.title {\n  font-size: 20px;\n  padding-left: 24px;\n  height: 20px;\n}\n\n.wrapper {\n  width: 700px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `styles_label__sZCjl`,
	"status": `styles_status__WYAil`,
	"rowControl": `styles_rowControl__vU0fK`,
	"clearButton": `styles_clearButton__hdVc1`,
	"addButtonCol": `styles_addButtonCol__yvb96`,
	"clearButtonCol": `styles_clearButtonCol__uTMOL`,
	"loading": `styles_loading__8psuw`,
	"spaceBetween": `styles_spaceBetween__-R1zP`,
	"containerBanck": `styles_containerBanck__-f2ZL`,
	"bankName": `styles_bankName__e4E3F`,
	"modalHeader": `styles_modalHeader__3Mg4m`,
	"form": `styles_form__C+2PH`,
	"footer": `styles_footer__MyHOf`,
	"containerTable": `styles_containerTable__0Jdnz`,
	"tableZ": `styles_tableZ__6oPVP`,
	"table": `styles_table__cu6sn`,
	"tableFinal": `styles_tableFinal__OxGzZ`,
	"title": `styles_title__REpXs`,
	"wrapper": `styles_wrapper__nC6yn`
};
export default ___CSS_LOADER_EXPORT___;
